import React from 'react';
import PageContentWrapper from "../../components/PageContentWrapper";
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getApi } from '../../api/endpoints';
import DetailsComponent from '../../components/DetailsComponent'
import FleetOwner from '../../models/FleetOwner'
import TabsComponent from '../../components/TabsComponent'
import FleetOwnerCustomersListing from '../../pages/customers/Listing'
import GroupsListing from '../../pages/group/Listing'
import UserDocuments from '../document/Listing.js'
import LeaseOffers from '../lease_offers/Listing.js'
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import { toast } from 'react-toastify';

const Show = () => {
  const [fleetOwnerDetails, setFleetOwnerDetails] = useState(new FleetOwner().toStateJson());
  const [fetchApi] = getApi('fleetOwnerDetails');
  const [canCreateLeaseOffer, setCanCreateLeaseOffer] = useState(false);
  const [tabs, setTabs] = useState([
      {
        event:'fleet_owner_customers',
        heading:'Customers',
        component: <><FleetOwnerCustomersListing/></>,
        ui_action: 'view_customers_under_fo_list'
      },
      {
        event:'groups',
        heading:'Groups',
        component: <GroupsListing/>,
        ui_action: 'view_fleet_owner_groups_list'
      },
      // {
      //   event: 'user_documents',
      //   heading: 'User Documents',
      //   component: <UserDocuments />,
      //   ui_action: 'view_user_documents'
      // },
    ]);
  const params = useParams();
  // const defaultTabs = ;
  useEffect(()=>{
    getRecord({id: params.id})
  }, []);

  useEffect(() => {
    if(canCreateLeaseOffer) {
      setTabs((prevState)=> {
        return [
      {
        event:'fleet_owner_customers',
        heading:'Customers',
        component: <><FleetOwnerCustomersListing/></>,
        ui_action: 'view_customers_under_fo_list'
      },
      {
        event:'groups',
        heading:'Groups',
        component: <GroupsListing/>,
        ui_action: 'view_fleet_owner_groups_list'
      },
      // {
      //   event: 'user_documents',
      //   heading: 'User Documents',
      //   component: <UserDocuments />,
      //   ui_action: 'view_user_documents'
      // },
      {
        event: 'users_lease_offers',
        heading: 'Lease Offers',
        component: <LeaseOffers defaultParams={{user_id: params.id}}/>,
        ui_action: 'view_fleet_owner_lease_offers'
      }]
    })
    }
  }, [fleetOwnerDetails])

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setFleetOwnerDetails((new FleetOwner(response.data.fleet_owner)).toStateJson());
      if(response.data.fleet_owner.can_create_lease_offer){
        setCanCreateLeaseOffer(response.data.fleet_owner.can_create_lease_offer);
      }
    } catch(error) {
      toast.error(error.data?.message || "Something went wrong !");
    }
  }

return <Page
    uiPage={uiManager.getUiPage(PAGES.ShowFleetOwnerPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Fleet Owners", url: "/fleet_owners" }, { label: `${params.id}` }]}
    className={'view-fleet-owners-page'}
  >
    <PageContentWrapper contentHeading={"Fleet Owner Details"}>
      <DetailsComponent data={fleetOwnerDetails} />
      <div className="mt-3">
      <TabsComponent data={tabs} defaultActiveEvent={'fleet_owner_customers'} />
      </div>
    </PageContentWrapper>
  </Page>
};

export default Show;
